import React from 'react'
import styled from "styled-components"
import lysImg from "../images/lys.png"

const Separator = styled.div`
    margin: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
const Line = styled.div`
    height: 2px;
    background-color: #982822;
    width: 35%;
`

const Lys = styled.img`
    height: 50px;
    margin: 2px 10px 2px 10px;
`

function LysSeparator() {
    return (
        <Separator>
            <Line />
                <Lys src={lysImg} alt="lys" />
            <Line />
        </Separator>
    )
}

export default LysSeparator
